import axios from 'axios';

import { BACKEND_URL } from '../config'  // Auto-fixed: use centralized config;
const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Properties API
export const propertiesAPI = {
  // Get all properties with optional filters
  getAll: async (filters = {}) => {
    const { category, location, minPrice, maxPrice, guests, bedrooms } = filters;
    const params = new URLSearchParams();
    
    if (category && category !== 'all') params.append('category', category);
    if (location) params.append('location', location);
    if (minPrice) params.append('min_price', minPrice);
    if (maxPrice) params.append('max_price', maxPrice);
    if (guests) params.append('guests', guests);
    if (bedrooms !== undefined && bedrooms !== null) params.append('bedrooms', bedrooms);
    
    const response = await api.get(`/properties?${params.toString()}`);
    return response.data;
  },

  // Get single property by ID
  getById: async (id) => {
    const response = await api.get(`/properties/${id}`);
    return response.data;
  },

  // Create new property
  create: async (propertyData) => {
    const response = await api.post('/properties', propertyData);
    return response.data;
  },

  // Update property
  update: async (id, propertyData) => {
    const response = await api.put(`/properties/${id}`, propertyData);
    return response.data;
  },

  // Delete property
  delete: async (id) => {
    const response = await api.delete(`/properties/${id}`);
    return response.data;
  },

  // Search properties
  search: async (searchParams) => {
    const { location, checkIn, checkOut, guests } = searchParams;
    const params = new URLSearchParams();
    
    if (location) params.append('location', location);
    if (checkIn) params.append('check_in', checkIn);
    if (checkOut) params.append('check_out', checkOut);
    if (guests) params.append('guests', guests);
    
    const response = await api.get(`/search?${params.toString()}`);
    return response.data;
  },
};

// Reviews API
export const reviewsAPI = {
  // Get reviews for a property
  getByPropertyId: async (propertyId) => {
    const response = await api.get(`/properties/${propertyId}/reviews`);
    return response.data;
  },

  // Create new review
  create: async (propertyId, reviewData) => {
    const response = await api.post(`/properties/${propertyId}/reviews`, reviewData);
    return response.data;
  },

  // Delete review
  delete: async (reviewId) => {
    const response = await api.delete(`/reviews/${reviewId}`);
    return response.data;
  },
};

// Categories API
export const categoriesAPI = {
  getAll: async () => {
    const response = await api.get('/categories');
    return response.data;
  },
};

export default api;
